export default __webpack_public_path__ + "static/media/IMG_1.cfa72230.png";